import '@splidejs/splide/css';
import Splide from '@splidejs/splide';


const initializeBlock = function( $block ){
  // console.log($block);
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  console.log('Initializing slider block:', $block);

  let slider;
  let isGridContainerMobileSlider = $block.classList.contains('grid-container') && $block.classList.contains('mobile-slider');
  const isAdmin = document.body.classList.contains('wp-admin');

  if($block.classList.contains('slider_block')){
    console.log('setting slider block slider');
    slider = $block.querySelector('.slider_block__slider');
  }
  else if(isGridContainerMobileSlider){
    // console.log('setting grid container slider');
    slider = $block;
  }

  if(!slider){ 
    return; 
  }

  if(slider.splide){
    // If the slider already exists, destroy it first
    slider.splide.destroy();
    slider.splide = null;
  }

  // For slides that don't already have the .splide__slide class, add it
  const slides = slider.querySelectorAll('.splide__list > *');
  Array.prototype.forEach.call(slides, function(el, i){
    if(!el.classList.contains('splide__slide')){
      el.classList.add('splide__slide');
    }
  });

  // Set up Args (rewritte for grid container mobile slider)
  const arrowPath = 'M22.92 19.58L7.69 4.35L12.04 0L31.62 19.58L12.04 39.16L7.69 34.8L22.92 19.58Z';
  let args = { 
    gap: '3rem',
    drag: isAdmin ? false : true,
    arrowPath: arrowPath,
    breakpoints: {
      1920: {
        gap : '2rem'
      },
      1200: {}, // Ready for population
      990: {
        gap : '1.2rem'
      },
      767: {} // Ready for population
    }
  };

  if(isGridContainerMobileSlider){
    const mobilePerPage = $block.getAttribute('data-slides-per-page-mobile') || 1;
    const tabletPerPage = $block.getAttribute('data-slides-per-page-tablet') || 1;

    args.perPage = parseInt(mobilePerPage);
    args.mediaQuery = 'min';
    args.breakpoints = {
      640: {
        perPage: parseInt(tabletPerPage),
      },
      991: {
        destroy: true,
      }
    }
  }
  else {
    if($block.classList.contains('slider-auto-start')){
      args.autoplay = true;
      args.interval = $block.getAttribute('data-td-speed') || 3000;
      args.pauseOnHover = false;
    }
  
    if($block.getAttribute('data-transition-type') === 'fade'){
      args.type = 'fade';
      args.rewind = true;
      args.speed = 1400;
    }
  
    // Set Per Page Args
    const defaultPerPageDesktop = $block.classList.contains('slider-type-card') ? 4 : 1;
    const defaultPerPageLaptop = $block.classList.contains('slider-type-card') ? 3 : 1;
    const defaultPerPageTablet = $block.classList.contains('slider-type-card') ? 2 : 1;
    const defaultPerPageMobile = 1;
    const slidesPerPageDesktop = parseInt($block.getAttribute('data-slides-per-page-desktop')) || defaultPerPageDesktop;
    // For laptop, fallback to a set desktop value if no laptop value is set
    const slidesPerPageLaptop = parseInt($block.getAttribute('data-slides-per-page-laptop')) ? parseInt($block.getAttribute('data-slides-per-page-laptop')) : parseInt($block.getAttribute('data-slides-per-page-desktop')) || defaultPerPageLaptop;
    const slidesPerPageTablet = parseInt($block.getAttribute('data-slides-per-page-tablet')) || defaultPerPageTablet;
    const slidesPerPageMobile = parseInt($block.getAttribute('data-slides-per-page-mobile')) || defaultPerPageMobile;
    args.perPage = slidesPerPageDesktop;
    args.breakpoints['1920'].perPage = slidesPerPageLaptop;
    args.breakpoints['1200'].perPage = slidesPerPageTablet;
    args.breakpoints['767'].perPage = slidesPerPageMobile;
  
    // Set Slides Per Move if required
    if($block.classList.contains('match-slides-per-move')){
      args.perMove = args.perPage;
      args.breakpoints['1920'].perMove = args.breakpoints['1920'].perPage;
      args.breakpoints['1200'].perMove = args.breakpoints['1200'].perPage;
      args.breakpoints['767'].perMove = args.breakpoints['767'].perPage;
    }
    else {
      args.perMove = 1;
    }
  }

  // Slider UI Options
  if($block.classList.contains('no-pagination')){
    args.pagination = false;
  } else if($block.classList.contains('has-pagination')){
    args.pagination = true;
  }
  if($block.classList.contains('has-arrows')){
    args.arrows = true;
  } else if($block.classList.contains('no-arrows')){
    args.arrows = false;
  }

  if(slider){
    // Create the slider
    slider.splide = new Splide(slider, args); 
    
    let currentSlideIndex = 0;

    // Update navigation count / progess bar
    const navWrap = slider.querySelector('.splide__arrows');
    const leftArrow = slider.querySelector('.splide__arrow--prev');
    const rightArrow = slider.querySelector('.splide__arrow--next');
    
    if(!!navWrap){
      slider.splide.on('move', (newIndex) => {
        if(args.rewind || args.rewindByDrag){ return; }
        
        const leftArrow = slider.querySelector('.splide__arrow--prev');
        const rightArrow = slider.querySelector('.splide__arrow--next');

        if(newIndex == 0 && !!leftArrow){
          leftArrow.disabled = true;
        }
        else if(!!leftArrow && leftArrow.disabled){
          leftArrow.disabled = false;
        }
        
        if(newIndex > (slider.splide.length - 1 - slider.splide.options.perPage) && !!rightArrow){
          rightArrow.disabled = true;
        }
        else if(!!rightArrow && rightArrow.disabled){
          rightArrow.disabled = false;
        }
      });

      slider.splide.on( 'move mounted resized', (newIndex) => {
        let current = newIndex + 1 || 1; // Splide is 0 indexed, but we want to be 1 indexed for the user. Also, on mounted event, newIndex is undefined, so we fallback to 1.
        const {Slides} = slider.splide.Components;

        // Progress bar
        const lastVisibleSlide = current + (slider.splide.options.perPage - 1);
        const progressBar = slider.querySelector('.progress');
        if(progressBar){
          let progress;
          
          if(args.perMove == args.perPage){
            progress = Math.round((current) / (Slides.getLength() - slider.splide.options.perPage) * 100);
          }
          else {
            progress = Math.round(lastVisibleSlide / Slides.getLength() * 100);
          }
          
          // Ensure resize events don't trip things up. 
          if(progress > 100){
            progress = 100;
          }

          progressBar.style.setProperty('--progress', progress + '%');
        }
      } );
    }

    // Ensure active class on new slide is added on move, rather than after move
    slider.splide.on('move', (newIndex) => {
      currentSlideIndex = newIndex;
      
      const allSlides = slider.querySelectorAll('.splide__slide');
      Array.prototype.forEach.call(allSlides, function(el, i){
        el.classList.remove('is-active');
        el.classList.remove('is-visible');
        
        // Add visible class to slides in view
        if(i >= newIndex && i < (newIndex + slider.splide.options.perPage)){
          el.classList.add('is-visible');
        }
        // Add active class to the current slide
        if(i == newIndex){
          el.classList.add('is-active');
        }
      });
    });
    
    // Mount the slider
    slider.splide.mount();
  }
}

const AdjustMobileGridSliderMarkup = function( $block ){
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  // Add splide elements
  if(!$block.classList.contains('splide')){
    const inner = $block.querySelector('.grid-container_wrapper');
    $block.classList.add('splide');

    const splideTrack = document.createElement('div');
    splideTrack.classList.add('splide__track');

    inner.classList.add('splide__list');
    inner.childNodes.forEach(child => {
      if(child.nodeType === Node.ELEMENT_NODE){
        child.classList.add('splide__slide');
      }
    });

    splideTrack.appendChild(inner);
    $block.appendChild(splideTrack);

    const splideUI = document.createElement('div');
    splideUI.classList.add('splide__ui');
    
    const progress = document.createElement('span');
    progress.classList.add('splide__progress', 'progress');
    splideUI.appendChild(progress);

    const arrows = document.createElement('div');
    arrows.classList.add('splide__arrows');
    splideUI.appendChild(arrows);

    $block.appendChild(splideUI);
  }

}


// Initialize the slider on the front end only
export const initializeSlider = function(){
  // Grid Container Mobile Sliders
  const gridMobileSliders = document.querySelectorAll('.grid-container.mobile-slider');
  Array.prototype.forEach.call(gridMobileSliders, function(el, i){
    AdjustMobileGridSliderMarkup(el);
  });

  const sliders = document.querySelectorAll('.slider_block, .grid-container.mobile-slider, .lwir');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
};


// Initialize the slider in the editor
export const initializeSliderEditor = () => {
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=slider', ( $block ) => {
      const slider = $block[0].querySelector('.slider_block');
      if(!slider) return;
      initializeBlock( slider );
    });
  }
}